"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuPillTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/components/ui/dropdown-menu";
import { parseCatalogOrder, type CatalogOrder } from "@/lib/host-panel/catalog-order";

/**
 * The catalog's order control (handoff v2 §6.3): the DS's Dropdown Menu, never a native `select`
 * (filters spec §6). No visible "Ordenar" label — the trigger names the current option, and
 * tells a screen reader "Ordenar: {opção}". The active option sits on porcelain-tint with the
 * green check after its text; the menu, 240px, opens under the trigger's right edge.
 */
export function CatalogOrderMenu({
  value,
  options,
  onChange,
}: {
  value: CatalogOrder;
  options: readonly { key: CatalogOrder; label: string }[];
  onChange: (next: CatalogOrder) => void;
}) {
  const current = options.find((option) => option.key === value) ?? options[0];

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuPillTrigger aria-label={`Ordenar: ${current.label}`}>{current.label}</DropdownMenuPillTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        // The v2 handoff's own entrance: 220ms on linen, rising 6px, with no zoom.
        className="w-60 min-w-60 data-[state=open]:zoom-in-100 data-[state=closed]:zoom-out-100 data-[state=open]:slide-in-from-top-1.5 data-[state=open]:duration-[var(--tb-duration-2)] data-[state=open]:ease-[var(--tb-ease-linen)]"
      >
        <DropdownMenuRadioGroup value={current.key} onValueChange={(next) => onChange(parseCatalogOrder(next))}>
          {options.map((option) => (
            <DropdownMenuRadioItem
              key={option.key}
              value={option.key}
              className="data-[state=checked]:bg-[var(--tb-porcelain-tint)]"
            >
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
